import { environment } from '@env/fe';
import { CurrentEnvironment } from '@twaice-fe/environments/shared';
import { LoginConfig } from '@twaice-fe/shared/models';
import { keysToCamel } from '@twaice-fe/shared/utilities';
import { Amplify } from 'aws-amplify';

const fetchLoginConfig = async () => {
  let attempt = 0;
  const maxRetries = 9;
  let loginConfig: LoginConfig | undefined;

  while (attempt < maxRetries) {
    try {
      const response = await fetch(environment.baseUrlApi + `authn-config?domain_origin=${window.location.origin}`, {
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();
        loginConfig = keysToCamel(data) as LoginConfig;
        localStorage.setItem(`authn-config`, JSON.stringify(loginConfig));
        break;
      }

      throw await response.json();
    } catch (error) {
      console.error('Error fetching login config', error);

      const backoff = Math.pow(2, attempt) * 1000;
      await new Promise((resolve) => setTimeout(resolve, backoff));
    } finally {
      attempt++;
    }
  }

  return loginConfig;
};

export const configureAmplify = async () => {
  let loginConfig: LoginConfig | undefined;
  let cachedConfig: LoginConfig | undefined;
  try {
    cachedConfig = JSON.parse(localStorage.getItem(`authn-config`));
  } catch (error) {
    cachedConfig = undefined;
  }

  if (cachedConfig) {
    // if there's a cached config, we use it and refresh the cache in the background
    loginConfig = cachedConfig;
    fetchLoginConfig();
  } else {
    loginConfig = await fetchLoginConfig();
  }

  if (!loginConfig) {
    window.location.reload();
  }

  CurrentEnvironment.setLoginConfig(loginConfig);

  try {
    Amplify.configure({
      Auth: {
        region: loginConfig.awsRegion,
        userPoolId: loginConfig.userPoolId,
        userPoolWebClientId: loginConfig.appClientId,
        oauth: loginConfig.ssoConfig
          ? {
              domain: loginConfig.ssoConfig.domain,
              scope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
              redirectSignIn: loginConfig.ssoConfig.redirectUrl,
              redirectSignOut: loginConfig.ssoConfig.redirectUrl,
              responseType: 'code',
            }
          : {},
        cookieStorage: {
          path: '/',
          expires: 365,
          secure: true,
          sameSite: 'strict',
        },
      },
    });
  } catch (error) {
    await fetchLoginConfig();
  }
};
